import { CheckCircle2, Circle } from "lucide-react";
import { PASSWORD_RULES } from "@/lib/passwordRules";

// Checklist real-time di bawah input password baru -- centang ijo begitu
// syarat terpenuhi, supaya user tahu SEBELUM submit (bukan baru tahu lewat
// pesan error backend setelah gagal).
export default function PasswordRequirements({ password }) {
    const pw = password || "";
    return (
        <ul className="mt-1.5 grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1">
            {PASSWORD_RULES.map((rule) => {
                const ok = rule.test(pw);
                return (
                    <li key={rule.key} className={`flex items-center gap-1.5 text-[11px] ${ok ? "text-emerald-600" : "text-slate-400"}`}>
                        {ok ? <CheckCircle2 className="w-3.5 h-3.5 flex-shrink-0" /> : <Circle className="w-3.5 h-3.5 flex-shrink-0" />}
                        {rule.label}
                    </li>
                );
            })}
        </ul>
    );
}
